import React from "react";
import { Link } from "react-router-dom";

import aboutImg from "../../assets/img/about/about-2.png";
import shapeImg1 from "../../assets/img/about/about-shape-3.png";
import shapeImg2 from "../../assets/img/about/about-shape-4.png";
import shapeImg3 from "../../assets/img/about/about-shape-5.png";

const About = () => {
  return (
    <div className="about-2__area pt-100 pb-130 p-relative fix">
      <div className="about-2__shape-1 d-none d-xl-block">
        <img src={shapeImg1} alt="" />
      </div>
      <div className="about-2__shape-2 d-none d-xl-block">
        <img src={shapeImg2} alt="" />
      </div>
      <div className="about-2__shape-3 d-none d-xl-block">
        <img src={shapeImg3} alt="" />
      </div>
      <div className="container">
        <div className="row align-items-center">
          <div
            className="col-xl-6 col-lg-6 wow animate__fadeInLeft"
            data-wow-duration=".9s"
            data-wow-delay=".5s"
          >
            <div className="about-2__main-img p-relative">
              <img
                src={aboutImg}
                alt="Ayush Mishra - Full-Stack App Developer"
              />
              <div className="about-2__main-img-content d-flex align-items-center">
                <div className="about-2__icon">
                  <span>
                    <i className="fal fa-check-circle"></i>
                  </span>
                </div>
                <div className="about-2__img-text">
                  <h5>50+</h5>
                  <span>Projects Built & Deployed</span>
                </div>
              </div>
            </div>
          </div>
          <div
            className="col-xl-6 col-lg-6 wow animate__fadeInRight"
            data-wow-duration=".9s"
            data-wow-delay=".7s"
          >
            <div className="about-2__item">
              <div className="about-2__section-title">
                <h4 className="section-subtitle char-anim">About Me</h4>
                <h3 className="section-title char-anim">
                  Building Apps That Transform How Businesses Operate
                </h3>
              </div>
              <div className="about-2__text">
                <p className="char-anim-2">
                  I create powerful web apps, mobile apps, and desktop
                  applications that solve real business challenges. Whether you
                  need a restaurant POS system, inventory management solution,
                  or custom CRM - I build applications that automate your
                  workflows and dramatically improve efficiency.
                </p>
              </div>
              <div
                className="about-2__list-item wow animate__fadeInUp"
                data-wow-duration=".9s"
                data-wow-delay=".9s"
              >
                <h4 className="about-2__list-title">Get In Touch:</h4>
                <ul>
                  <li style={{ width: "100%", float: "none" }}>
                    <span>Ayush Mishra</span>
                  </li>
                  <li style={{ width: "100%", float: "none" }}>
                    <span>Delhi, India</span>
                  </li>
                  <li style={{ width: "100%", float: "none" }}>
                    <span>ayushmishra7352@gmail.com</span>
                  </li>
                  <li style={{ width: "100%", float: "none" }}>
                    <span>WhatsApp: +91 8802487352</span>
                  </li>
                </ul>
              </div>
              <div
                className="about-2__button wow animate__fadeInUp"
                data-wow-duration=".9s"
                data-wow-delay="1.1s"
              >
                <Link to="/about" className="it-btn tp-btn-hover alt-color">
                  <span>
                    Know More About Me<i className="fal fa-arrow-right"></i>
                  </span>
                  <b></b>
                </Link>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default About;
